module.exports = __webpack_public_path__ + "img/DawnFarm.1fc92b34.jpg";